<template>
	<div>
		<a-modal :title="'睡眠报告'" :visible="isShowAlert" :maskClosable="false"
			@cancel="hiddenAlert"
			:dialog-style="{ 'min-width': '1000px', 'max-width': '1000px', 'border-radius': '16px', 'background': '#FFFFFF00', 'overflow': 'hidden', 'min-height': '862px', 'max-height': '862px' }"
			:footer="null" id="old" :zIndex="1000">
			<div class="needGZ_TanWrap" v-if="isShowAlert">
				<div class="needGZ_Tan"
					style="width: 1000px;height: 862px; display: flex; flex-direction: column; padding-bottom: 25px; background: #ECF0F3; position: relative;">

					<div v-if="loading"
						style="width:1000px;height:862px;position: fixed;background:#FFFFFF00;z-index: 999999;display:flex;justify-content: center;align-items: center;">
						<a-spin :allSpinning="loading" tip="加载中" :delay="100" size="large"></a-spin>
					</div>

					<div v-if="exporting"
						style="width:1000px;height:862px;position: fixed;background:rgba(33, 35, 37, 0.3);z-index: 999999;display:flex;justify-content: center;align-items: center;">
						<a-spin :allSpinning="loading" tip="请耐心等待，不要离开此页面，正在导出中..." :delay="100" size="large"></a-spin>
					</div>

					<div style="display: flex; height: 65px; position: relative;">
						<img style="position: absolute; width: 100%; height: 65px;"
							src="../../../assets/icon_dean_home_alert_bg_3.png" alt="">
						<div
							style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; justify-content: space-between; align-items: center;">
							<div style="display: flex; align-items: center; height: 100%;">
								<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px;">
								</div>
								<div
									style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 20px;">
									需要长期观察的长者</div>
								<div style="display: flex; align-items: center; margin-left: 5px;">
									<img style="width: 7px; height: 8px; z-index: 1;"
										src="../../../assets/icon_common_special_arrow_2.png" alt="" />
									<div
										style="margin-left: -2px; background: #FBF6CB; border-radius: 4px; border: 1px solid #ECE271; padding: 2px 5px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #E6BA0A; line-height: 20px;">
										{{ (data && data.longObserveElderVoPage && data.longObserveElderVoPage.total) ? (data && data.longObserveElderVoPage && data.longObserveElderVoPage.total) + '位' : '0位'  }}</div>
								</div>
							</div>
							<img style="width: 36px; height: 36px; margin-right: 15px; cursor: pointer;"
								src="../../../assets/icon_common_close_1.png" alt=""
								@click="hiddenAlert" />
						</div>
					</div>

					<div class="needGZ_Cont" style="flex: 1; display: flex; flex-direction: column; background: #ECF0F3;">
						<QlBtn :text="'导出当前所有长者信息'" style="margin-top: 15px; margin-left: 0px; align-self: flex-start;"
							@btnClick="epxportAllInfo" />
						<div style="flex: 1;">
							<div style="width: 100%; display: flex; flex-wrap: wrap;"
								v-if="data && data.longObserveElderVoPage && data.longObserveElderVoPage.records">
								<div class="miniCardHover" v-for="(subItem, subIndex) in data.longObserveElderVoPage.records"
									style="width: 223px; height: 199px; box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF; border-radius: 16px; display: flex; flex-direction: column; margin-top: 20px;"
									:style="{ marginRight: (subIndex + 1) % 4 == 0 ? '0px' : '19px' }"
									@click="miniCardClick(subItem)">
									<div style="flex: 1; display: flex; position: relative; justify-content: center;">
										<div style="flex: 1; margin-bottom: 10px; margin-left: 5px; margin-right: 5px; margin-top: 5px; background: #FAFAF0; border-radius: 12px; border: 1px solid #ECE271; display: flex; flex-direction: column; justify-content: space-between;">
											<div class="richTextDiv" style="display: flex; flex-wrap: wrap; overflow: hidden; max-height: 108px; align-items: flex-start; justify-content: flex-start;">
												<div 
												class="description"
												v-for="(miniItem, miniIndex) in subItem.hasOccurPrfList || []" 
												style="background: rgba(235, 210, 16, 0.15); border-radius: 8px; height: 40px; margin-top: 10px; display: flex; align-items: center; position: relative; margin-left: 10px; padding-left: 10px; padding-right: 10px;"
												>
													<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 170px;">{{ miniItem }}</div>
												</div>
											</div>
											<div style="display: flex; height: 34px; justify-content: space-between; margin-bottom: 10px; padding-left: 10px; padding-right: 10px;">
												<div style="width: 38px; height: 24px; background: rgba(94, 103, 121, 0.1); border-radius: 19px 19px 19px 2px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; display: flex; align-items: center; padding-left: 8px;" :style="{opacity: subItem && subItem.hasOccurPrfList && subItem.hasOccurPrfList.length > 2 ? 1 : 0}">…</div>
												<div style="width: 58px; height: 30px; background: rgba(74, 124, 232, 0.15); border-radius: 20px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 20px; display: flex; justify-content: center; align-items: center; align-self: flex-end;">查看</div>
											</div>
										</div>
										<img style="position: absolute; width: 16px; height: 12px; bottom: 0px;"
											src="../../../assets/icon_common_special_arrow_4.png" alt="" />
									</div>
									<div class="bedName" style="display: flex; margin-bottom: 10px; align-items: center; justify-content: center; padding-left: 10px; padding-right: 10px; position: relative;">
										<div class="miniCardHoverImg" style="width: 20px; height: 20px; margin-right: 5px;" alt=""></div>
										<div class="miniCardHoverText" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 175px;">{{ subItem.bedName || '' }}</div>
										<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: -40px; padding: 10px; border-radius: 8px; display: none; z-index: 10000;" :style="{transform: (subIndex == 3 || subIndex == 7 || subIndex == 11) ? 'translateX(-50%)' : 'translateX(50%)'}">
											<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: wrap; overflow-wrap: break-word; color: rgba(94, 103, 121, 1); max-width: 300px; text-overflow: ellipsis; overflow: hidden;">{{ subItem.bedName || '' }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div style="background-color: #ECF0F3;"
						v-if="data && data.longObserveElderVoPage && data.longObserveElderVoPage.total">
						<a-pagination @change="changePage" :total="data.longObserveElderVoPage.total" :pageSize="pageSize"
							:hideOnSinglePage="true" show-less-items style="text-align: center;" />
					</div>
				</div>
			</div>
		</a-modal>

		<WorkProposalExport ref="workProposalExportRef" :type="1" @exportFinish="exportFinish"/>

	</div>
</template>
  
<script>
import QlBtn from '../../../component/common/qlBtn.vue'
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';
import WorkProposalExport from './workProposalExport.vue'

export default {
	components: { QlBtn, WorkProposalExport },
	filters: {
		reMate(val) {
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {

	},
	watch: {

	},
	data() {
		return {
			isShowAlert: false,
			pageNum: 1,
			pageSize: 12,
			data: null,
			loading: false,
			exporting: false,
			clickId: null
		};
	},
	created() { },
	mounted() {


	},
	methods: {

		openAlert() {
			this.isShowAlert = true;
			this.data = null;
			this.pageNum = 1;
			this.getListData();

			this.$get(
				'api/dean/v5/clickLog', {
					clickType: 4
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.clickId = res.data.id;
						} 
					} else {
					}
				}, (err) => {}
			);
		},
		hiddenAlert() {
			this.isShowAlert = false;
			this.$get(
				'api/dean/v5/closeLog', {
					id: this.clickId
				},
				(res) => {}, (err) => {}
			);
		},
		miniCardClick(item) {
			this.$emit('itemClick', item);
		},
		// 当日需及时关心的长者 - 全部
		getListData() {
			this.loading = true;
			this.$get(
				'api/dean/v5/longObserveElderPage',
				{
					pageNum: this.pageNum,
					pageSize: this.pageSize
				},
				(res) => {
					this.loading = false;
					if (res.code == 0) {
						if (res.data) {
							this.data = res.data;
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					this.loading = false;
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		changePage(e) {
			this.pageNum = e;
			this.getListData();
		},
		epxportAllInfo() {
			this.getHomeDataFirst();

			this.$get(
				'api/dean/v5/clickLog', {
					clickType: 5
				},
				(res) => {}, (err) => {}
			);
		},
		getHomeDataFirst() {
			this.$get(
				'api/dean/v5/longObserveElderList',
				{}, (res) => {
					if (res.code == 0) {
						if (res.data && res.data.longObserveElderVoList && res.data.longObserveElderVoList.length > 0) {
							// 开始执行导出
							this.$refs.workProposalExportRef.executeExport(res.data.longObserveElderVoList)
							this.exporting = true;
						} 
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		exportFinish() {
			this.exporting = false;
			this.$message.success('导出成功', 1.5);
		}
	},
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.miniCardHover {
	background: #ECF0F3;
	cursor: pointer;
	.miniCardHoverText {
		color: #5E6779;
	}

	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_6.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.miniCardHover:hover {
	background: #DFE8FC;

	.miniCardHoverText {
		color: #4A7CE8;
	}

	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_7.png') no-repeat no-repeat;
		background-size: contain;
	}
}


::v-deep .ant-pagination-item {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #ECF0F3;
}

::v-deep .ant-pagination-item:hover {
	background: #DFE8FC;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #DFE8FC;
}

::v-deep .ant-pagination-item-active {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid rgba(74, 124, 232, 0.5);
}

::v-deep .ant-pagination-item-link {
	background: #ECF0F3;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 0px solid #ECF0F3;
}

::v-deep .ant-pagination-item-link:hover {
	background: #DFE8FC;
	box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF;
	border-radius: 10px;
	border: 1px solid #DFE8FC;
}

::v-deep .ant-pagination-disabled .ant-pagination-item-link {
	background: #ECF0F3;
	border-radius: 10px;
	border: 1px solid rgba(202, 205, 217, 0.5);
	box-shadow: unset;
}

.richTextDiv ::v-deep {
	.richContentStyle {
		display: flex;
		max-width: 170px;
	}

	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
	}

	.richTextStyleRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
	}
}

.description:hover {
	.showDescription {
		display: block !important;
	}
}

.bedName:hover {
	.showDescription {
		display: block !important;
	}
}

</style>
  